var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "tableBox" },
    [
      _c(
        "el-table",
        { attrs: { data: _vm.tableData } },
        [
          _c("el-table-column", {
            attrs: { type: "index", width: "20px", label: "#" }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "occurredDate",
              width: "110px",
              label: "事发时间",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "description",
              label: "事件描述",
              "min-width": "200px",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "eventLevel",
              width: "80px",
              label: "事件等级",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "eventType",
              width: "120px",
              label: "事件类型",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "eventReason",
              width: "80px",
              label: "事件原因",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "eventPhase",
              width: "80px",
              label: "事发阶段",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "company",
              width: "80px",
              label: "航空公司",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "reasonAnalysis",
              label: "原因分析",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "deathToll",
              align: "center",
              width: "80px",
              label: "死亡人数",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "updateTime",
              width: "110px",
              label: "更新时间",
              "show-overflow-tooltip": true
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              property: "operateUser",
              width: "80px",
              label: "操作人",
              "show-overflow-tooltip": true
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-wrapper" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              layout: "prev, pager, next",
              total: _vm.page.total,
              "current-page": _vm.page.num,
              "page-size": _vm.page.size
            },
            on: {
              "update:currentPage": function($event) {
                return _vm.$set(_vm.page, "num", $event)
              },
              "update:current-page": function($event) {
                return _vm.$set(_vm.page, "num", $event)
              },
              "update:pageSize": function($event) {
                return _vm.$set(_vm.page, "size", $event)
              },
              "update:page-size": function($event) {
                return _vm.$set(_vm.page, "size", $event)
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5eee985c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5eee985c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/achievement/result/AccidentDetail.vue
// module id = null
// module chunks = 